export default "__VITE_ASSET__tU0UY7Uo__"